<template>
  <pe-renderer :imgErrorTemplate="imgErrorTemplate" :imgPdf="imgPdf"></pe-renderer>
</template>

<script>
import 'piivo-poster-engine/src/static/style/views/renderer.scss';

import peRenderer from 'piivo-poster-engine/src/views/PosterRenderer.vue';

import imgErrorTemplate from '../static/img/error-template.jpg';
import imgPdf from '../static/img/pdf.jpg';

export default {
  components: {
    peRenderer,
  },
  data() {
    return {
      imgErrorTemplate,
      imgPdf,
    };
  },
};
</script>
